import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, GiftIcon, ShieldCheckIcon } from 'lucide-react';
export function Hero() {
  return <header className="w-full bg-ink text-white" data-id="element-41" data-mp="eilh9dyhbbh9">
      <div className="mx-auto w-full max-w-readable px-6 pb-16 pt-14 sm:pb-20 sm:pt-20" data-id="element-42" data-mp="9ka6n10d0wxz">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} data-id="element-43" data-mp="4lywep65kkf8">
          <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/5 px-3 py-1 text-xs font-medium uppercase tracking-widest text-white/70" data-id="element-44" data-mp="1274nzp1vrg78">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-45" data-mp="s9qa9x7cd5im" />
            Tu regalo
          </span>

          <p className="mt-8 text-base text-white/60" data-id="element-46" data-mp="nbyj55eitnfh">
            👋 Me alegra que hayas comentado <strong className="font-semibold text-white" data-id="element-47" data-mp="3d33fj0i70xlt">EXPERTO</strong>.
          </p>

          <h1 className="mt-3 text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-6xl" data-id="element-48" data-mp="381nvnbrr4x50">
            Protocolo CNS
          </h1>

          <p className="mt-5 max-w-xl text-lg leading-relaxed text-white/75 sm:text-xl" data-id="element-49" data-mp="3j6oe7qokeyt9">
            Las primeras 5 verificaciones que hacemos antes de entregar un iPhone.
          </p>

          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/55" data-id="element-50" data-mp="39cfjqxfz4vsg">
            Todos los días pasan decenas de iPhone por el local para configurarlos. Antes de entregar
            cualquiera, siempre revisamos estas cinco configuraciones. Te recomiendo hacerlas ahora mismo.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-x-6 gap-y-3 text-sm text-white/60" data-id="element-51" data-mp="35au9ljutqvly">
            <span className="inline-flex items-center gap-2" data-id="element-52" data-mp="2qi0l58xkr555">
              <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-53" data-mp="2vjq02znx42yi" />
              No tardás más de 2 minutos
            </span>
            <span className="inline-flex items-center gap-2" data-id="element-54" data-mp="2hl9sz7m58afu">
              <ShieldCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-55" data-mp="2ljpcv2mxh2p1" />
              17 años trabajando con Apple
            </span>
          </div>
        </motion.div>
      </div>
    </header>;
}